

import React, { useRef, useState, useEffect, useContext } from 'react';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import noahAvatar from '../../assets/images/Icon_Logo.png';
import './RightChatComponent.css';
import ChatWithLLM from '../../Apis/ChatWithLLM';
import FetchChatHistoryById from '../../Apis/FetchChatHistoryById';
import { useParams } from 'react-router-dom';
import MyContext from '../../Context/AppContext';
import { useNavigate } from 'react-router-dom'
import { showToast } from '../../utils/toastUtils';
import { KeyboardVoice, StopCircle } from '@mui/icons-material';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import BackDropLoader from '../backDropLoader/BackDropLoader';
import { v4 as uuidv4 } from 'uuid';
import Sendmessage from "../../assets/icons/sendmessage"
import Userlogo from '../../assets/icons/userlogo';

const RightChatComponent = (props) => {
    const { jobDescriptionStatus, setJobDescriptionStatus, checkLimitExceed,
        openDrawer, setIsBackdropEnabled, resetJobDescriptionStatus, userDetails, limitExceededApiRunning,
        chatLimitExceeded, setChatLimitExceeded, setUpgradeModalOpen } = useContext(MyContext);
    const [chatHistory, setChatHistory] = useState([]);
    const [currentUserInput, setCurrentUserInput] = useState('');
    const [userInputWithoutTranscript, setUserInputWithoutTranscript] = useState('');
    const [isBotThinking, setIsBotThinking] = useState(false);
    const [isVoiceEnabled, setIsVoiceEnabled] = useState(false);
    const [showPopupButtons, setShowPopupButtons] = useState(false);
    const [isChatDisabled, setIsChatDisabled] = useState(false);
    const scrollContainerRef = useRef(null);
    const lastFetchedId = useRef(null);
    const inputRef = useRef(null)
    const { id } = useParams();
    const {
        transcript,
        resetTranscript,
    } = useSpeechRecognition();
    const navigate = useNavigate();

    const handleCurrentUserInput = (e) => {
        resetTranscript();
        setCurrentUserInput(e.target.value);
        setUserInputWithoutTranscript(e.target.value);
    };

    const handleintentselect = async (message) => {
        const newUserMessage = {
            title: 'You',
            description: message,
        };

        setChatHistory((prevHistory) => [...prevHistory, newUserMessage]);
        setShowPopupButtons(false);
        setIsChatDisabled(false);
        setCurrentUserInput('');
        setUserInputWithoutTranscript('');
        setIsVoiceEnabled(false);
        SpeechRecognition.stopListening();
        setIsBotThinking(true);
        handleChatWithLLM(message);
    };

    const handleSendMesaage = async () => {
        if (currentUserInput === '' || isChatDisabled) return;

        const newUserMessage = {
            title: 'You',
            description: currentUserInput,
        };
        resetTranscript();
        setChatHistory((prevHistory) => [...prevHistory, newUserMessage]);
        setCurrentUserInput('');
        setUserInputWithoutTranscript('');
        setIsVoiceEnabled(false);
        SpeechRecognition.stopListening();
        setIsBotThinking(true);
        handleChatWithLLM(currentUserInput);
    };

    const handleSupportClick = () => {
        setUpgradeModalOpen(true);
    };

    useEffect(() => {
        window.handleSupportClick = handleSupportClick;
        return () => {
            delete window.handleSupportClick;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        window.selectCustomer = (customerName) => handleintentselect(customerName);
        return () => {
            delete window.selectCustomer;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const containsHtml = (text) => /<[a-z][\s\S]*?>/i.test(text);

    const formatTextWithNewlines = (text) => {
        if (!text) return null;

        // If the message contains HTML tags, render it as HTML
        if (containsHtml(text)) {
            // Replace known placeholder onclick patterns
            const processedText = text.replace(
                /<a href='#' onClick={myFunction\(\)}>([^<]+)<\/a>/g,
                `<a href="#" class="support-link" onclick="handleSupportClick()">$1</a>`
            );
            return <div dangerouslySetInnerHTML={{ __html: processedText }} />;
        }

        // Plain text: split by newlines
        const lines = text.split("\n");
        return lines.map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ));
    };

    const goToNewChat = async () => {

        setJobDescriptionStatus({
            isContinueChat: false,
            isEmailSent: false,
            isTestCreated: false,
        });

        let limitExceedStatus = await checkLimitExceed()
        let createJdAccess = userDetails?.accountConfig?.permissions?.createJd
        if (limitExceedStatus || createJdAccess === false) {
            navigate('/app/limitExceeded')
        }
        else {
            // Generate a new UUID and navigate directly to the new chat route
            const newChatId = uuidv4();
            navigate(`/app/chat/${newChatId}`);
        }
    }

    const handleChatWithLLM = async (userinput) => {
        const userId = userDetails?._id;
        const data = { sessionId: id, message: userinput, userId: userId };
        const response = await ChatWithLLM(data);
        let jobDescriptionStatusResponse = {
            isContinueChat: response?.data?.isContinueChat,
            isEmailSent: response?.data?.isEmailSent,
            isTestCreated: response?.data?.isTestCreated,
        }
        setChatLimitExceeded(response?.data?.isChatLimitExceeded)
        setJobDescriptionStatus(jobDescriptionStatusResponse);
        let botResponse = response?.data?.response;

        setChatHistory((prevHistory) => [
            ...prevHistory,
            {
                title: 'Noah',
                description: botResponse,
            },
        ]);
        setIsBotThinking(false);
        setTimeout(() => {
            inputRef.current?.querySelector('input')?.focus();
        }, 100);
        if ((jobDescriptionStatusResponse.isEmailSent === true ||
            jobDescriptionStatusResponse.isEmailSent === "inprocess") 
            && jobDescriptionStatusResponse.isContinueChat === true) {
            showToast('Thank you for generating the job description', 'success');
        }
        if ((jobDescriptionStatusResponse.isTestCreated === true ||
            jobDescriptionStatusResponse.isTestCreated === "inprocess")
            && jobDescriptionStatusResponse.isContinueChat === true) {
            showToast('Thank you for generating the tests.', 'success');
        }
    };

    const userName = userDetails?.name;
    function formatName(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const handleVoiceChat = () => {
        if (!isVoiceEnabled) {
            setIsVoiceEnabled(true);
            SpeechRecognition.startListening({ continuous: true });
        } else {
            setIsVoiceEnabled(false);
            SpeechRecognition.stopListening();
        }
    }

    useEffect(() => {
        if (transcript) {
            let updatedTranscriptText = "";
            updatedTranscriptText = userInputWithoutTranscript + transcript;
            setCurrentUserInput(updatedTranscriptText);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [transcript, userInputWithoutTranscript]);


    useEffect(() => {
        async function fetchData() {
            if (!id || lastFetchedId.current === id) return;
            lastFetchedId.current = id;
            SpeechRecognition.stopListening();
            setCurrentUserInput('');
            setIsBackdropEnabled(true);
            resetJobDescriptionStatus();
            setChatHistory([]);
            await fetchChatHistory();
            resetTranscript();
            setIsVoiceEnabled(false);
        }
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        if (limitExceededApiRunning) {
            setIsBackdropEnabled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [limitExceededApiRunning])

    const fetchChatHistory = async () => {
        try {
            const response = await FetchChatHistoryById(id);
            if (response.data.response.data.length === 0) {
                let limitExceedStatus = await checkLimitExceed()
                let createJdAccess = userDetails?.accountConfig?.permissions?.createJd
                if (limitExceedStatus || createJdAccess === false) {
                    navigate('/app/limitExceeded')
                    return;
                }
                // Show popup buttons for new chat
                let userhasTestsCreationAccess = userDetails?.accountConfig?.permissions?.createTests;
                if (userhasTestsCreationAccess) {
                    setShowPopupButtons(true);
                    setIsChatDisabled(true);
                }
                const userId = userDetails?._id;
                const data = { sessionId: id, message: 'Start Over', userId: userId };
                await ChatWithLLM(data);
                if (userhasTestsCreationAccess) {
                    setChatHistory([{
                        title: 'Noah',
                        description: 'Hi! What do you want to do today?',
                        showButtons: true
                    }]);
                }
            } else {
                let responseData = response?.data?.response?.data[0].history;
                let jdcreated = response?.data?.response?.data[0]?.jdcreated || false;
                let testcreated = response?.data?.response?.data[0]?.testcreated || false;
                let intent = response?.data?.response?.data[0]?.intent || '';
                let jdmetadataexists = response?.data?.response?.data[0]?.jdmetadata.length > 0 ? true : false;
                let testmetadataexists = response?.data?.response?.data[0]?.testmetadata.length > 0 ? true : false;
                let isEmailSent = response?.data?.response?.data[0]?.emailsent || false;

                if ((!testcreated || !testmetadataexists) && (!jdcreated || !jdmetadataexists)) {

                    resetJobDescriptionStatus();
                    showToast('Continue chat not supported in this version', 'error');
                    const newChatId = uuidv4();
                    navigate(`/app/chat/${newChatId}`);
                }
                else {

                    let chatData = [];
                    for (let i = 0; i < responseData.length; i++) {
                        let obj = {};
                        if (responseData[i].type === 'human') {
                            obj.title = 'You';
                            obj.description = responseData[i].message;
                        } else if (responseData[i].type === 'ai') {
                            obj.title = 'Noah';
                            obj.description = responseData[i].message;
                        }
                        chatData.push(obj);
                    }
                    setChatHistory(chatData || []);
                    // Enable chat for existing conversations

                    let disablechat = false;

                    if (intent === 'test_creation') {
                        if (testcreated || testmetadataexists) {
                            disablechat = true;
                            let isTestCreatedStatus = testcreated ? true : (testmetadataexists ? "inprocess" : false)
                            setJobDescriptionStatus(prevStatus => ({
                                ...prevStatus,
                                isTestCreated: isTestCreatedStatus
                            }));
                        }
                    }
                    else if (intent === 'jd_creation') {
                        if ((jdcreated && jdmetadataexists) || (jdcreated && isEmailSent)) {
                            disablechat = true;
                            let isEmailSentStatus = isEmailSent ? true : jdmetadataexists ? "inprocess" : false
                            setJobDescriptionStatus(prevStatus => ({
                                ...prevStatus,
                                isEmailSent: isEmailSentStatus
                            }));
                        }
                    }
                    setIsChatDisabled(disablechat);
                    setShowPopupButtons(false);
                }
            }
        } catch (error) {
            console.error('Error fetching chat history:', error);
            setChatHistory([]);
        } finally {
            setIsBackdropEnabled(false)
        }
    };

    useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo({
                top: scrollContainerRef.current.scrollHeight,
                behavior: 'smooth',
            });
        }
    }, [chatHistory]);

    return (
        <div className={openDrawer ? "mainContainer_chatDiv drawerOpen_chatContainer" : "mainContainer_chatDiv"}>
            <div ref={scrollContainerRef} className={chatHistory.length > 0 ? 'chatContainer' : 'chatContainer_blank'}>

                {chatHistory.length === 0 ? (
                    <div className="chatGreetingContent">

                        <span className="chatGreetingTitle">Hello, {userName ? formatName(userName) : "User"}</span>
                        <span className="chatGreetingTitle2">How can I help you today?</span>
                    </div>
                ) : (
                    <div className="chatContentContainer">

                        {chatHistory.map((chat, index) => {
                            return (
                                <div key={index} className={chat.title === 'You' ? 'chatContentDiv rightAllignmentMessage' : 'chatContentDiv'}>
                                    <span className={chat.title === 'You' ? 'senderTitle_user' : 'senderTitle'}>
                                        {chat.title}
                                    </span>
                                    <div className={chat.title === 'You' ? 'senderMessageContainer senderMessageContainerReverse' : 'senderMessageContainer'}>
                                        {chat.title === 'You' ? (
                                            <Userlogo className="senderAvatar" />
                                        ) : (
                                            <img src={noahAvatar} className="senderAvatar" alt="sendAvatar" />
                                        )}
                                        <div className={chat.title === 'You' ? 'senderMessageDiv_user' : 'senderMessageDiv'}>
                                            {formatTextWithNewlines(chat.description)}
                                            {chat.showButtons && showPopupButtons && (
                                                <div className="popup-buttons-container">
                                                    <button
                                                        className="popup-button job-description-btn"
                                                        onClick={() => handleintentselect("I want to create a job description")}
                                                    >
                                                        Create Job Description
                                                    </button>
                                                    <Tooltip
                                                        title={(userDetails?.accountConfig?.permissions?.createTests === false) ?
                                                            "Test creation is disabled because your organization does not have the required internal customer access" : null}
                                                    >
                                                        <button
                                                            className="popup-button create-test-btn"
                                                            onClick={() => handleintentselect("I want to create a test")}
                                                            disabled={userDetails?.accountConfig?.permissions?.createTests === false ? true : false}
                                                        >
                                                            Create Test
                                                        </button>
                                                    </Tooltip>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                        {isBotThinking && (
                            <div className="chatContentDiv">
                                <span className="senderTitle">Noah</span>
                                <div className="senderMessageContainer">
                                    <img src={noahAvatar} className="senderAvatar" alt="sendAvatar" />
                                    <div className="senderMessageDiv BotLoaderDiv">
                                        <div className="botResponseloader"></div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {(chatLimitExceeded && (!jobDescriptionStatus?.isEmailSent || !jobDescriptionStatus?.isTestCreated)) &&
                <div className='chatLimitExceededContainer'>
                    <span className='chatLimitText'>
                        ** Your chat limit has been exceeded. To increase your limit, please contact support.
                    </span>
                </div>
            }

            {jobDescriptionStatus?.isTestCreated === true || jobDescriptionStatus?.isEmailSent === true ?
                <div className='chatLimitExceededContainer jdCreatedContainer'>
                    <span className='chatLimitText'>
                        ** The {jobDescriptionStatus?.isTestCreated ? "Tests" : "Job Description"} for this chat has already been generated
                        {jobDescriptionStatus?.isEmailSent ? " and sent to your email" : ""}
                        . To create a new one, please
                    </span>
                    <span className='newChatCreateText' onClick={() => goToNewChat()}> click here</span>
                </div>
                :
                jobDescriptionStatus?.isTestCreated === "inprocess" || jobDescriptionStatus?.isEmailSent === "inprocess" ?
                    <div className='chatLimitExceededContainer jdCreatedContainer'>
                        <span className='chatLimitText'>
                            {jobDescriptionStatus?.isTestCreated === "inprocess" ? "** The Tests for this chat is being created and will show up in this chat shortly. To create a new one, please"
                                : "** The generated Job Description for this chat will be sent to your email shortly. To create a new one, please"}
                        </span>
                        <span className='newChatCreateText' onClick={() => goToNewChat()}> click here
                        </span>
                    </div>
                    :
                    <div className="chatInputBoxCaontainer">
                        <TextField
                            className='chatInputBox'
                            id="outlined-multiline-flexible"
                            multiline
                            maxRows={6}
                            placeholder="Ask me anything..."
                            onChange={handleCurrentUserInput}
                            disabled={chatLimitExceeded || isChatDisabled}
                            autoComplete="off"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey && currentUserInput !== '' && !isBotThinking) {
                                    e.preventDefault();
                                    handleSendMesaage();
                                }
                            }}
                            value={currentUserInput}
                            slotProps={{
                                input: {
                                    endAdornment: <InputAdornment position="end">
                                        <div className='wrapper'>
                                            <div className='voiceConatinerMain'>
                                                {isVoiceEnabled && (
                                                    <div>
                                                        <div class="waves-block">
                                                            <div class="waves wave-1"></div>
                                                            <div class="waves wave-2"></div>
                                                            <div class="waves wave-3"></div>
                                                        </div>
                                                    </div>)}
                                                <IconButton className='voiceEnableIcon' onClick={() => handleVoiceChat()} disabled={chatLimitExceeded || isChatDisabled}>
                                                    {isVoiceEnabled ? <StopCircle /> :
                                                        <KeyboardVoice />
                                                    }
                                                </IconButton>
                                            </div>

                                        </div>

                                    </InputAdornment>,
                                },
                            }}
                        />
                        <IconButton className="sendIconButton" onClick={handleSendMesaage} disabled={isBotThinking || chatLimitExceeded || isChatDisabled}>
                            <Sendmessage className={isBotThinking || currentUserInput.length <= 0 || isChatDisabled ? 'sendIconButtonDisabled sendIconImage' : 'sendIconImage'}/>
                        </IconButton>
                    </div>
            }
            <BackDropLoader />
        </div>
    );
};

export default RightChatComponent;
